// Constants
import { ViewRenderState } from "@ms/uno-constants/lib/local/ViewConstants";
import { StoreEntityState } from "@ms/uno-constants/lib/local/StoreConstants";
import { Store } from "@ms/planner-stores/lib/local/stores/Store";
/**
 * Calculates the render state for left nav
 * @param storeLoader store loader
 * @param configProvider config provider
 */ export function calculateLeftNavRenderState(storeLoader, configProvider) {
    const config = configProvider();
    const [mruStore, orgStore, tenantStore, portfolioStore, permissionsStore, planStore] = storeLoader.loadAll([
        Store.Mru,
        Store.Org,
        Store.Tenant,
        Store.Portfolio,
        Store.Permissions,
        Store.Plan
    ]);
    // Get critical data from stores
    const pinnedItems = mruStore.getPinnedItems();
    const visiblePinnedItems = pinnedItems.data.filter((item)=>!planStore.isDefaultPlan(item.serverDocId));
    const isMruFetched = pinnedItems != null && pinnedItems.status.state !== StoreEntityState.Absent;
    const isMruDataLoaded = pinnedItems != null && visiblePinnedItems.length >= config.settings.performanceSettings.minimumPlansForVisualReadiness;
    // Get non-critical data from stores
    const isOrgDataFetched = orgStore.getDefaultCdsInstance()?.status.state !== StoreEntityState.Absent;
    const isTenantDataFetchedOrNotNeeded = !config.flights.EnablePortfolioExperience || tenantStore.getCurrentTenantPortfoliosEnabledSetting()?.status.state !== StoreEntityState.Absent;
    const shouldFetchPortfolioItems = config.changeGates.DisableLicenseCheckForGetPortfoliosCall || permissionsStore.getUserPermissions().canCreatePortfolios;
    const isPortfolioDataFetchedOrNotNeeded = !config.flights.EnablePortfolioExperience || (shouldFetchPortfolioItems ? portfolioStore.getPortfolioItems()?.status.state !== StoreEntityState.Absent : true);
    if (isOrgDataFetched && isTenantDataFetchedOrNotNeeded && isPortfolioDataFetchedOrNotNeeded && isMruFetched) {
        return ViewRenderState.All;
    } else if (isMruDataLoaded || isMruFetched) {
        return ViewRenderState.Critical;
    }
    return ViewRenderState.None;
}
